<template lang="pug">
div
  //- DO NOT REMOVE THIS....THIS MAGIC RIGHT HERE MAKES IT ALL WORK
  //- https://www.w3schools.com/tags/att_base_target.asp
  base(target='_top')
  #configureTech
</template>

<script setup lang="ts">
definePageMeta({
  layout: 'blank',
})

/**
* Adding new Configure Tech
* 1) Add case statement in this file
* 2) Add path to pages/product/routes.js
* 3) Shim store/product/mutations.js
* controls.integration = {
      params: {
          plc: 'LS',
      },
  }

  https://localhost:3000/p/dash-designs-dashtex-dash-cover/v/ford/f150-lightning/2022/
  https://localhost:3000/p/seat-designs-scottsdale-seat-covers/v/chevy/silverado-1500/2024/
  https://localhost:3000/p/lloyd-mats-rubbertite-cargo-liner/v/ford/f150-lightning/2022/
  https://localhost:3000/p/ruff-tuff-saddle-blanket-seat-covers/v/ford/f150-lightning/2022/
  https://localhost:3000/p/avery-s-sport-touring-floor-mats/v/ford/f150-lightning/2022/
  https://localhost:3000/p/wet-okole-neoprene-seat-covers/
*/

onMounted(() => {
  const rootStore = useRootStore()
  const { $sitewideConfig } = useNuxtApp()
  const route = useRoute()
  if (Array.isArray(route.query.params)) return

  const queryParams = JSON.parse(route.query?.params || '')
  let brandCode = null
  let manufacturerPrefix = null
  let dynamicFieldName = null

  switch (route.query.brandName) {
    case 'Lloyd Mats':
      brandCode = 'CLRB'
      manufacturerPrefix = 'LYD'
      dynamicFieldName = 'lloyd_code'
      break
    case 'Dash Topper':
    case 'Seat Designs':
    case 'Dash Designs':
      brandCode = 'BGWL'
      manufacturerPrefix = 'DDI'
      dynamicFieldName = 'dynamic_part_number'
      break
    case 'Ruff Tuff':
      brandCode = 'FWNK'
      manufacturerPrefix = 'RTP'
      dynamicFieldName = 'dynamic_part_number'
      break
    case "Avery's":
      brandCode = 'BGRG'
      manufacturerPrefix = 'AVR'
      dynamicFieldName = 'dynamic_part_number'
      break
    case 'Wet Okole Hawaii':
      brandCode = 'JRNN'
      manufacturerPrefix = 'WEO'
      dynamicFieldName = 'dynamic_part_number'
      break
  }

  const options = {
    container: 'configureTech',
    postBackUrl: window.location.origin + '/checkout/cart/?3rdParty=configureTech',
    apiKey: $sitewideConfig.config.configureTechApiKey,
    brandCode,
    productLineCode: queryParams.params.pl,
    etailerPostBackParameters: {
      sid: rootStore.permId,
      manufacturerPrefix,
      dynamicFieldName,
    },
  }
  const { addSrc, load, addCallback } = runScriptOnDemand()
  addSrc('https://ctiapi.com/js/angular-app/widget/cti-widget.js')
  addCallback(() => {
    Configurator.init(options)
  })
  load()
})
</script>
